export const Languages = {
  PT_BR: 'pt-BR',
}

export const LanguagesLabels: { [key: string]: string } = {
  'pt-BR': 'Português (pt-BR)',
}
